module.exports = __webpack_public_path__ + "img/1547389829.3af54c6c.jpg";